const ViewContractApply = () => import('../modules/xmsb/energy/operators/ViewContractApplyGzl')

export default [
  {

    path: '/contractapplyview',
    name: 'contractapplyview',
    component: ViewContractApply,
    meta: {
      title: '对外承包工程大项目',
      fullscreen: true,
    },
  },
]
